import { MessageMedium, SubscriptionPolicy } from '../domain';

export enum QueryParam {
  search = 'search',
  policy = 'policy',
  status = 'subscribed',
  medium = 'medium',
}

export enum Filter {
  policy = 'policy',
  status = 'status',
  medium = 'medium',
}

export const POLICY_DISPLAY_NAMES = {
  [SubscriptionPolicy.optIn]: 'Opt-in',
  [SubscriptionPolicy.optOut]: 'Opt-out',
  [SubscriptionPolicy.doubleOptIn]: 'Double opt-in',
};

export const SUBSCRIPTION_STATE_DISPLAY_NAMES = {
  true: 'Subscribed',
  false: 'Unsubscribed',
};

export const MESSAGE_MEDIUM_DISPLAY_NAMES = {
  [MessageMedium.Email]: 'Email',
  [MessageMedium.InApp]: 'In-App',
  [MessageMedium.SMS]: 'SMS',
  [MessageMedium.Push]: 'Push',
  [MessageMedium.WebPush]: 'Web Push',
};

export const KNOWLEDGE_CENTER_ARTICLE_URL =
  'https://support.iterable.com/hc/en-us/articles/204780529-Message-Channels-and-Message-Types-Overview-';
